import { HttpAgent, randomUUID, type Message } from '@ag-ui/client'
import type { AuthenticatedFetch } from '../types/network'

export function createAgent(
  url: string,
  threadId: string,
  authenticatedFetch: AuthenticatedFetch,
  initialMessages?: Message[],
): HttpAgent {
  return new HttpAgent({
    url,
    threadId,
    fetch: authenticatedFetch,
    description: 'AG-UI LangGraph chat agent with MCP Apps support',
    ...(initialMessages ? { initialMessages } : {}),
  })
}

export function createThreadId(): string {
  return `thread_${randomUUID()}`
}
